import React, { useCallback, useEffect, useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import AgentTab from "./agentConfig";
import HuntGroupTab from "./huntGroupConfig";
import TemplateTab from "./templateConfig";
import apiClient from "../../axiosClient";
import CallerDIDTab from "./callerDidConfig";

import HuntGroup from "./interface/huntGroup";
import Template from "./interface/template";
import Agent from "./interface/agent";
import CallerDid from "./interface/callerDid";

const ManageDialerConfig: React.FC = () => {
	const [activeTab, setActiveTab] = useState(0);
	const [loading, setLoading] = useState<boolean>(false);

	const [huntGroups, setHuntGroups] = useState<HuntGroup[]>([]);
	const [agents, setAgents] = useState<Agent[]>([]);
	const [templates, setTemplates] = useState<Template[]>([]);
	const [callerDids, setCallerDids] = useState<CallerDid[]>([]);

	const fetchHuntGroups = useCallback(async () => {
		try {
			const response = await apiClient.get(`/api/v1/tcn_config/hunt_group`);
			if (response.status === 200) {
				setHuntGroups(response.data);
			}
		} catch (error) {
			console.error("Failed to fetch hunt groups", error);
		}
	}, []);

	const fetchTemplates = async () => {
		try {
			const response = await apiClient.get(`/api/v1/tcn_config/tcn_template`);
			if (response.status === 200) {
				setTemplates(response.data);
			}
		} catch (error: any) {
			console.error("Fetch Error", error);
		}
	};

	const fetchAgents = async () => {
		try {
			const response = await apiClient.get(`/api/v1/tcn_config/agent_with_hunt_group`);
			if (response.status === 200) {
				setAgents(response.data);
			}
		} catch (error: any) {
			console.error("Fetch Error", error);
		}
	};

	const fetchCallerDIDs = async () => {
		try {
			const response = await apiClient.get(`/api/v1/tcn_config/caller_did_agency_mapping?is_active=true`);
			if (response.status === 200) {
				setCallerDids(response.data);
			}
		} catch (error: any) {
			console.error("Fetch Error", error);
		}
	}

	useEffect(() => {
		try {
			setLoading(true);
			fetchHuntGroups();
			fetchTemplates();
			fetchAgents();
			fetchCallerDIDs();
		} catch (error: any) {
			console.error("Fetch Error", error);
		} finally {
			setLoading(false);
		}
	}, [])

	const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
		setActiveTab(newValue);
	};

	return (
		<Box sx={{ width: '100%' }}>
			<Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2, pt: 2 }}>
				<Tabs value={activeTab} onChange={handleTabChange}>
					<Tab label="Hunt Groups" />
					<Tab label="Templates" />
					<Tab label="Agents" />
					<Tab label="Caller DIDs"/>
				</Tabs>
			</Box>
			<Box>
				{activeTab === 0 && <HuntGroupTab loading={loading} huntGroups={huntGroups} availableAgents={agents.filter((agent) => !agent.hunt_group)} refreshHuntGroups={() => fetchHuntGroups()} refreshAgents={() => fetchAgents()}/>}
				{activeTab === 1 && <TemplateTab loading={loading} templates={templates} huntGroups={huntGroups} refresh={() => fetchTemplates()}/>}
				{activeTab === 2 && <AgentTab loading={loading} agents={agents} refresh={() => fetchAgents()}/>}
				{activeTab === 3 && <CallerDIDTab loading={false} callerDIDs={callerDids} refreshCallerDIDs={() => fetchCallerDIDs()}/>}
			</Box>
		</Box>
	);
};

export default ManageDialerConfig;